// File: /components/article/CustomStyles.js
import React from "react";
import { codeBlockStyles } from "./articleStyles";

export default function CustomStyles() {
  return <style>{codeBlockStyles}</style>;
}
